import { Instance, SnapshotOut, types } from "mobx-state-tree"
import {Timestamp} from "firebase/firestore";

/**
 * Action model.
 */
export const ActionModel = types.model("Action").props({
  id: types.maybe(types.string),
  projectId: types.string,
  businessId: types.string,
  name: types.string,
  amount: types.number,
  direction: types.string,
  actionKey: types.string,
  createdAt: types.maybe(types.string),
  updatedAt: types.maybe(types.string)
})

type ActionType = Instance<typeof ActionModel>
export interface Action extends ActionType {}
type ActionSnapshotType = SnapshotOut<typeof ActionModel>
export interface ActionSnapshot extends ActionSnapshotType {}

export const actionFromJson = (docData) => {
  const updatedAtTimeStamp: Timestamp | string | undefined = docData.updatedAt;
  const createdAtTimeStamp: Timestamp | string | undefined = docData.createdAt;

  console.log("actionFromJson", docData)

  return {
    id: docData.id,
    projectId: docData.projectId,
    businessId: docData.businessId,
    name: docData.name,
    amount: docData.amount,
    direction: docData.direction,
    actionKey: docData.actionKey,
    createdAt: createdAtTimeStamp instanceof Timestamp ? createdAtTimeStamp.toDate().toDateString() : createdAtTimeStamp,
    updatedAt: updatedAtTimeStamp instanceof Timestamp ? updatedAtTimeStamp.toDate().toDateString() : updatedAtTimeStamp
  }
}
